import React from "react";

const CorrectIcon = () => {
  return (
    <div
      className="size-12 flex items-center justify-center rounded-lg object-cover ring-1 ring-gray-900/10 text-gray-500 text-sm bg-green-100"
      style={{ width: "50px", height: "50px" }} // Adjust size as needed
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-6 h-6 text-green-600"
      >
        <path d="M20 6L9 17l-5-5" />
      </svg>
    </div>
  );
};

export default CorrectIcon;
